<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-cube', fontSet: 'fad'}"
	[headerText]="T.OPEN_CHANGE_RECORDING_META_DIALOG_TITLE | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div class="recordingMetaDataDialogCon">
			<form [formGroup]="metaDataForm">
				<mat-form-field class="full-width-form" color="accent">
					<mat-label>{{ T.OPEN_CHANGE_RECORDING_META_DIALOG_EVENT | translate }}</mat-label>
					<input formControlName="eventName" matInput type="text" />
				</mat-form-field>

				<mat-form-field class="full-width-form" color="accent">
					<mat-label>{{ T.OPEN_CHANGE_RECORDING_META_DIALOG_EVENT_DESCRIPTION | translate }}</mat-label>
					<textarea
						[cdkAutosizeMaxRows]="9"
						[cdkAutosizeMinRows]="1"
						[cdkTextareaAutosize]="true"
						formControlName="eventDescription"
						matInput
						placeholder="..."
					>
					</textarea>
				</mat-form-field>

				@if (hasLicenseModule(Modules.EventDesigner)) {
					<mat-form-field class="full-width-form" color="accent">
						<mat-label>{{ T.OPEN_CHANGE_RECORDING_META_DIALOG_SESSION | translate }}</mat-label>
						<input formControlName="sessionName" matInput type="text" />
					</mat-form-field>
				}

				@if (
					data.scenarioRecordingState === ScenarioRecordingState.Prepared ||
					data.scenarioRecordingState === ScenarioRecordingState.Stopped
				) {
					@if (hasLicenseModule(Modules.ScenarioDesigner)) {
						<sim-scenario-chip-input
							[label]="T.OPEN_CHANGE_RECORDING_META_DIALOG_SCENARIO | translate"
							[placeholder]="T.OPEN_CHANGE_RECORDING_META_DIALOG_SCENARIO | translate"
							[scenarioFc]="metaDataForm.controls.scenario"
						/>
					}
				}
			</form>
		</div>
	</ng-container>

	<ng-container actions>
		<div class="wrapper">
			<sim-button
				(onClick)="close({action: 'cancel'})"
				[color]="'warn'"
				[icon]="{fontSet: 'fal', fontIcon: 'fa-times'}"
				[label]="T.BUTTON_CANCEL"
			/>

			<sim-button
				(onClick)="okButtonClicked()"
				[color]="'accent'"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
				[label]="T.BUTTON_OK"
			/>
		</div>
	</ng-container>
</sim-basic-material-dialog>
